import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getPageTitle from '@/utils/get-page-title';
import orderConsumeDetails from './components/order-consume-details.vue';
import orderConsumeBusiness from './components/order-consume-business.vue';
// import orderConsumeCard from './components/order-consume-card.vue'
export default {
  components: {
    orderConsumeDetails: orderConsumeDetails,
    orderConsumeBusiness: orderConsumeBusiness
    // orderConsumeCard
  },
  beforeRouteEnter: function beforeRouteEnter(to, _, next) {
    var _to$query$searchData = to.query.searchData,
      searchData = _to$query$searchData === void 0 ? '{}' : _to$query$searchData;
    var _JSON$parse = JSON.parse(decodeURIComponent(searchData)),
      tag_type = _JSON$parse.tag_type;
    to.meta.title = {
      1: '业务类型数据分析',
      2: '卡类型数据分析'
    }[tag_type] || '订单数据分析';
    document.title = getPageTitle(to.meta.title);
    next();
  },
  props: {
    trendParams: {
      default: function _default() {
        return {};
      },
      type: Object
    }
  },
  data: function data() {
    return {
      orderId: '',
      is_total: '',
      searchData: {},
      activeNameDefault: '',
      detailActiveName: '',
      entry: ''
    };
  },
  created: function created() {
    if (Object.keys(this.trendParams).length > 0) {
      this.orderId = this.trendParams.order_id;
      this.is_total = this.trendParams.is_total;
      this.activeNameDefault = this.trendParams.activeNameDefault;
      this.detailActiveName = this.trendParams.detailActiveName;
      this.searchData = this.trendParams.searchData;
      this.entry = this.trendParams.entry;
      return;
    }
    var _this$$route$query = this.$route.query,
      order_id = _this$$route$query.order_id,
      is_total = _this$$route$query.is_total,
      _this$$route$query$se = _this$$route$query.searchData,
      searchData = _this$$route$query$se === void 0 ? '{}' : _this$$route$query$se,
      _this$$route$query$de = _this$$route$query.detailActiveName,
      detailActiveName = _this$$route$query$de === void 0 ? '1' : _this$$route$query$de;
    this.orderId = order_id;
    this.is_total = is_total;
    this.detailActiveName = detailActiveName;
    this.searchData = JSON.parse(decodeURIComponent(searchData));
  }
};